import { render, staticRenderFns } from "./NikudResultsContainer.vue?vue&type=template&id=dba9bafc&"
import script from "./NikudResultsContainer.vue?vue&type=script&lang=js&"
export * from "./NikudResultsContainer.vue?vue&type=script&lang=js&"
import style0 from "./NikudResultsContainer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports